import { render, staticRenderFns } from "./PopupSuggestedExerciseSwap.vue?vue&type=template&id=59d8da69"
import script from "./PopupSuggestedExerciseSwap.vue?vue&type=script&lang=js"
export * from "./PopupSuggestedExerciseSwap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports